<template>
  <b-sidebar
    id="sidebar-review-request-letter"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Reject or accept') }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <b-form
        class="p-2"
        @submit.prevent
      >
        <b-form-group
          :label="$t('Comment')"
          label-for="request-letter-comment"
        >
          <b-form-textarea
            id="request-letter-comment"
            v-model="comment"
            rows="4"
            :placeholder="$t('Comment')"
          />
        </b-form-group>

        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-2"
            @click="review(REQUEST_LETTER_STATUSES.ACCEPT, hide)"
          >
            {{ $t('Accept') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            class="mr-2"
            @click="review(REQUEST_LETTER_STATUSES.REJECT, hide)"
          >
            {{ $t('Reject') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { REQUEST_LETTER_STATUSES } from './config'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  props: {
    requestLetter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      comment: '',
      REQUEST_LETTER_STATUSES,
    }
  },
  watch: {
    requestLetter() {
      this.comment = ''
    },
  },
  methods: {
    review(status, hide) {
      this.$removeSwal(this, {
        id: this.requestLetter.id,
        status,
        comment: this.comment,
      }, 'requestLetters/review', () => {
        hide()
        this.comment = ''
        this.$emit('refetchData')
      }, {
        text: '',
        confirmButtonText: status === REQUEST_LETTER_STATUSES.ACCEPT ? 'Accept' : 'Reject',
        successTitle: 'Success',
        successText: 'Successfully completed',
        errorText: 'There was an error in successful execution',
      })
    },
  },
}
</script>
